import { FC } from 'react';
import { useIntl } from 'react-intl';
import { noop } from 'lodash';
import { Optional } from 'utility-types';
import { Button, createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { SearchBar, SearchBarProps } from '@app/components';
import { useQueryParams } from '@app/hooks';
import { sharedMessages } from '@app/translations';

import './BrowseSearch.scss';

type BrowseSearchProps = {
  label: string;
} & Optional<SearchBarProps, 'placeholder' | 'onSearch'>;

const cnBem = createBemBlockBuilder(['browseSearch']);

export const BrowseSearch: FC<BrowseSearchProps> = ({
  placeholder,
  label,
  onSearch = noop,
}) => {
  const { $t } = useIntl();
  const queryParams = useQueryParams();

  return (
    <section className={cnBem()} aria-label={label}>
      <SearchBar
        placeholder={placeholder}
        value={queryParams.search as string}
        onSearch={onSearch}
      />
      {queryParams.search && (
        <div className={cnBem('__buttonsWrapper')}>
          <Button styleType="pill" onClick={() => onSearch('')}>
            {$t(sharedMessages.clearResults)}
          </Button>
        </div>
      )}
    </section>
  );
};
